var _rect, _path, _rect2, _circle, _rect3, _rect4, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4, _circle5, _circle6, _rect5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 80,
    width: 100,
    height: 100,
    fill: "#1E90FF",
    rx: 15
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "roofGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4169E1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1E90FF",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80 Q100 30 160 80",
    fill: "url(#roofGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 140,
    width: 30,
    height: 40,
    fill: "#87CEEB",
    rx: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 160,
    r: 3,
    fill: "#4169E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 100,
    width: 30,
    height: 30,
    fill: "#B0E0E6",
    rx: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 100,
    width: 30,
    height: 30,
    fill: "#B0E0E6",
    rx: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 100 L65 130 L50 130 L50 100 Z",
    fill: "#87CEEB",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95 100 L95 130 L80 130 L80 100 Z",
    fill: "#87CEEB",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105 100 L105 130 L90 130 L90 100 Z",
    fill: "#87CEEB",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135 100 L135 130 L120 130 L120 100 Z",
    fill: "#87CEEB",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 40,
    r: 6,
    fill: "#87CEEB",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 35,
    r: 5,
    fill: "#87CEEB",
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 35,
    r: 5,
    fill: "#87CEEB",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 30,
    r: 4,
    fill: "#87CEEB",
    opacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 30,
    r: 4,
    fill: "#87CEEB",
    opacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180,
    width: 200,
    height: 20,
    fill: "#4169E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 180 Q20 170 25 180 Q30 170 35 180",
    fill: "#1E90FF",
    stroke: "#1E90FF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 180 Q60 170 65 180 Q70 170 75 180",
    fill: "#1E90FF",
    stroke: "#1E90FF",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100 180 Q100 170 105 180 Q110 170 115 180",
    fill: "#1E90FF",
    stroke: "#1E90FF",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140 180 Q140 170 145 180 Q150 170 155 180",
    fill: "#1E90FF",
    stroke: "#1E90FF",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180 180 Q180 170 185 180 Q190 170 195 180",
    fill: "#1E90FF",
    stroke: "#1E90FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e41330596b17207be05542f16d21afcd.svg";
export { ForwardRef as ReactComponent };